var map = {
	"./about/supplier/cancel.svg": 461,
	"./about/supplier/default-file.svg": 484,
	"./about/supplier/pdf.svg": 485,
	"./about/supplier/ppt.svg": 486,
	"./about/supplier/success.svg": 458,
	"./about/supplier/txt.svg": 487,
	"./about/supplier/upload-cloud.svg": 462,
	"./about/supplier/warning.svg": 459,
	"./about/supplier/word.svg": 488,
	"./about/time-left.svg": 546,
	"./add.svg": 547,
	"./address.svg": 548,
	"./all-function.svg": 549,
	"./apply_no.svg": 550,
	"./apply_phone.svg": 551,
	"./apply_user.svg": 552,
	"./arrow-down.svg": 553,
	"./billing-invoicing.svg": 554,
	"./btn-download.svg": 555,
	"./buttonDownload.svg": 556,
	"./check-mark.svg": 557,
	"./check.svg": 558,
	"./checked-active.svg": 559,
	"./checked.svg": 560,
	"./chevron-left.svg": 561,
	"./chevron-right.svg": 562,
	"./chevron-route.svg": 563,
	"./chevronDown.svg": 564,
	"./chevronUp.svg": 565,
	"./circle.svg": 566,
	"./clear.svg": 567,
	"./close-fat.svg": 568,
	"./close-pic.svg": 569,
	"./close-pic1.svg": 570,
	"./close.svg": 571,
	"./cn_logo.svg": 572,
	"./contact-chat.svg": 573,
	"./contact-email.svg": 574,
	"./contact-phone.svg": 575,
	"./contact-sale.svg": 576,
	"./contact-service.svg": 577,
	"./contact-whatapp.svg": 578,
	"./contact/computer.svg": 579,
	"./contact/email.svg": 580,
	"./contact/phone.svg": 581,
	"./contact/qq.svg": 582,
	"./contact/tel.svg": 583,
	"./contact_mobile_no.svg": 584,
	"./contact_mobile_noJp.svg": 585,
	"./contact_mobile_whatsApp.svg": 586,
	"./country/au.svg": 587,
	"./country/cn.svg": 588,
	"./country/de.svg": 589,
	"./country/eu.svg": 590,
	"./country/ex.svg": 591,
	"./country/fr.svg": 592,
	"./country/gb.svg": 593,
	"./country/hk.svg": 594,
	"./country/jp.svg": 595,
	"./country/kr.svg": 596,
	"./country/my.svg": 597,
	"./country/ru.svg": 598,
	"./country/sg.svg": 599,
	"./country/th.svg": 600,
	"./country/us.svg": 601,
	"./country/vn.svg": 602,
	"./customs-inquriy.svg": 603,
	"./delete.svg": 604,
	"./document.svg": 605,
	"./e-mail.svg": 606,
	"./edit.svg": 607,
	"./enterprise_login.svg": 453,
	"./eye-close.svg": 608,
	"./eye-open.svg": 609,
	"./faqA.svg": 610,
	"./faqQ.svg": 611,
	"./file-delete.svg": 612,
	"./fileType/excel-icon.svg": 613,
	"./fileType/pdf-icon.svg": 614,
	"./fileType/ppt-icon.svg": 615,
	"./fileType/txt-icon.svg": 616,
	"./fileType/word-icon.svg": 617,
	"./form/formCopy.svg": 618,
	"./form/formDelete.svg": 619,
	"./form/formEdit.svg": 620,
	"./header-country.svg": 621,
	"./header-lang.svg": 622,
	"./header-user.svg": 623,
	"./homeBackground1.svg": 463,
	"./homeBackground2.svg": 464,
	"./home_chaxun.svg": 624,
	"./home_chevron.svg": 625,
	"./home_clearanceService.svg": 626,
	"./home_del.svg": 627,
	"./home_lijichadan.svg": 628,
	"./home_mashangjijian.svg": 629,
	"./home_meun.svg": 630,
	"./home_yunfeishixiaochaxun.svg": 631,
	"./homemore.svg": 632,
	"./iconDown.svg": 633,
	"./iconFrom.svg": 634,
	"./iconMail.svg": 635,
	"./iconNoData.svg": 636,
	"./iconNotSupport.svg": 637,
	"./iconPartialSupport.svg": 638,
	"./iconPath.svg": 639,
	"./iconReceive.svg": 640,
	"./iconRight.svg": 641,
	"./iconSearch.svg": 642,
	"./iconSupport.svg": 643,
	"./icons/shipping-method.svg": 644,
	"./info.svg": 645,
	"./info_solid.svg": 646,
	"./lijichaxun.svg": 647,
	"./logo_black.svg": 648,
	"./logo_white.svg": 649,
	"./mail.svg": 650,
	"./mark_exclamation.svg": 651,
	"./mark_question.svg": 652,
	"./mark_question_solid.svg": 653,
	"./message/message_error.svg": 654,
	"./message/message_info.svg": 655,
	"./message/message_success.svg": 656,
	"./message/message_warning.svg": 657,
	"./message/message_warning_active.svg": 658,
	"./mobile-close.svg": 659,
	"./more.svg": 660,
	"./notify.svg": 661,
	"./notify1.svg": 662,
	"./notify2.svg": 663,
	"./package-box.svg": 664,
	"./pdf.svg": 665,
	"./personalCanada.svg": 454,
	"./personalUs.svg": 455,
	"./plus.svg": 666,
	"./queryWaybill.svg": 667,
	"./question.svg": 456,
	"./right-nav-back-top.svg": 668,
	"./search-left.svg": 669,
	"./search.svg": 670,
	"./sendMail.svg": 671,
	"./senderPerson.svg": 489,
	"./shipment-complaints.svg": 672,
	"./solidArrow.svg": 673,
	"./submitHistoryIcon.svg": 674,
	"./support/apply-type.svg": 675,
	"./support/direction.svg": 676,
	"./support/doc-upload-type.svg": 677,
	"./support/freightArrow.svg": 678,
	"./support/freightDelivery.svg": 679,
	"./support/freightEdit.svg": 680,
	"./support/support_curve.svg": 681,
	"./support/support_exchange.svg": 682,
	"./support/support_title_bg.svg": 683,
	"./symbol-add.svg": 684,
	"./take-picture.svg": 685,
	"./trash-2.svg": 686,
	"./upload.svg": 687,
	"./waybill/collect.svg": 688,
	"./waybill/delivered.svg": 689,
	"./waybill/delivery.svg": 690,
	"./waybill/express-direction.svg": 691,
	"./waybill/invalid.svg": 692,
	"./waybill/landing.svg": 693,
	"./waybill/other.svg": 694,
	"./waybill/packaged.svg": 695,
	"./waybill/pickedup.svg": 696,
	"./waybill/picking.svg": 697,
	"./waybill/received.svg": 698,
	"./waybill/signed.svg": 699,
	"./waybill/take_off.svg": 700,
	"./wechat.svg": 701,
	"./whole-calculate.svg": 702,
	"./whole-shipping.svg": 703,
	"./whole-tracking.svg": 704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2221;